import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-90px" }}
    transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`text-[11px] font-medium uppercase tracking-[0.35em] text-[#C19D60] ${className}`}>
    {children}
  </p>
);
